import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
@Component({
  selector: 'app-ae-summary-case-stock',
  templateUrl: './ae-summary-case-stock.component.html',
  styleUrls: ['./ae-summary-case-stock.component.scss']
})
export class AeSummaryCaseStockComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  // @Output() emitEditCase: EventEmitter<any> = new EventEmitter();
  @Output() viewCasebyId: EventEmitter<any> = new EventEmitter()

  aeSummaryCaseStockDatatable: DataTables.Settings = {}
  dtTrigger: Subject<any> = new Subject()
  subscription: Subscription
  initTableFirstTime = false
  listHeader
  listShow
  listTable
  asc = 1
  desc = -1

  constructor(private store: StoreService, private cpmService: CpmService) { }

  ngOnInit() {
    this.listTable = []
    this.listHeader = [
      'Case ID',
      'Symbol',
      'Service objective',
      'Team',
      'Case owner',
      'Status'
    ]

    this.aeSummaryCaseStockDatatable = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      ordering: false,
      destroy: true
    }

    this.getInformation()
  }

  getInformation() {
    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.listTable = []

    this.cpmService.getlistCrmCase().then(
      success => {
        const listData = success
        // console.log(listData, '-- test ListData')
        listData.map(obj => {
          const list = {
            id: obj.id,
            securitySymbol: obj.securitySymbol,
            companyNameThai: obj.companyNameThai,
            caseId: obj.caseId,
            team: obj.team,
            type: obj.type,
            meetingObjective: obj.meetingObjective,
            caseStatus: obj.caseStatus,
            caseOwner: obj.caseOwner,
            lastUpdateDate: obj.lastUpdateDate
          }
          this.listTable.push(list)
        })
        this.listTable = this.sortList(this.listTable, 'id', this.asc)
        // console.log(this.listTable, '-- this.listTable');

        if (!this.initTableFirstTime) {
          this.dtTrigger.next()
          this.initTableFirstTime = true
        } else {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.dtTrigger.next()
          })
        }
      },
      err => { }
    )
  }

  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }

  noDividendData() {
    return this.listTable.length > 0 ? false : true
  }

  editCase(id, symbol) {
    this.store.setOutputCaseByIdBehavior(id)
    this.store.setSearchInputBehavior(symbol)

    this.viewCasebyId.emit({ id: id, symbol: symbol })
  }

  get ws_data_toExcel() {
    const ws_data = [];

    ws_data.push([...this.listHeader]);
    this.listTable.map(data => {
      ws_data.push([
        data.caseId,
        data.securitySymbol,
        data.meetingObjective,
        data.team,
        data.caseOwner,
        data.caseStatus
      ]);
    })
    return ws_data;

  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary-case-stock/ae-summary-case-stock.component.ts